module.exports = __webpack_public_path__ + "static/img/hairjx.b3ed7ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hairjx.png
// module id = 1hUq
// module chunks = 3